import { useState } from "react";
import Card from "components/card";
import axiosClient from "axios-client";
import { Link } from "react-router-dom";
import { isValidUUID } from "utils/validation";
import InputField from "components/fields/InputField";

export default function RequestNewAccount() {
    const [message, setMessage] = useState({});
    const [state, setState] = useState({
        email: null,
        name: null,
        code: null,
    });

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        setState((state) => ({ ...state, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!isValidUUID(state.code)) {
            setMessage({
                text: "Codice Cliente: inserire un UUID valido con formato: 00000000-0000-0000-0000-000000000000",
                type: "ERROR",
            });

            return;
        } else {
            setMessage({});
        }

        setMessage({});

        axiosClient
            .post("/auth/signup", state)
            .then(({ status }) => {
                if (status === 200) {
                    setMessage({
                        text: "Registrazione effettuata. Riceverai a breve una mail per completare l'attivazione del tuo account.",
                        type: "SUCCESS",
                    });
                }
            })
            .catch((err) => {
                const response = err.response;

                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    };

    return (
        <div className="mt-0 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mt-16 lg:mb-10 lg:items-center lg:justify-start">
            <div className="mx-auto mt-0 w-full max-w-full flex-col items-center lg:mt-[10vh] xl:max-w-[544px]">
                <Card extra="p-6 md:p-[32px]">
                    <Link to="/auth/sign-in">
                        <img
                            src="/img/logo.svg"
                            alt="Proxima"
                            className="mx-auto mb-4 w-64 p-0"
                        />
                    </Link>

                    <hr className="-mx-6 mb-6 border-lightPrimary md:-mx-[40px]" />

                    <h4 className="mb-2.5 text-center text-3xl font-bold text-gray-800 dark:text-white">
                        Non hai ancora un account?
                    </h4>

                    <p className="mb-6 ml-1 text-center text-[14.5px] text-gray-800">
                        Inserisci email, nome e codice cliente per ricevere una
                        mail di attivazione del tuo account.<br/>
                        Non possiedi ancora il tuo codice cliente? Ti invitiamo a contattare il tuo Account o il tuo Area Manager per richiederlo.
                    </p>

                    <form onSubmit={handleSubmit}>
                        {/* Email */}
                        <InputField
                            extra="mb-4"
                            label="Email*"
                            placeholder="email@esempio.com"
                            type="email"
                            name="email"
                            value={state.email || ""}
                            onChange={handleChange}
                            required={true}
                            state={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("email")
                                        ? "error"
                                        : null
                                    : null
                            }
                            error={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("email")
                                        ? message.errors.email
                                        : null
                                    : null
                            }
                        />

                        {/* Name */}
                        <InputField
                            extra="mb-4"
                            label="Nome*"
                            placeholder="Mario Rossi"
                            name="name"
                            value={state.name || ""}
                            onChange={handleChange}
                            required={true}
                            state={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("password")
                                        ? "error"
                                        : null
                                    : null
                            }
                            error={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("password")
                                        ? message.errors.password
                                        : null
                                    : null
                            }
                        />

                        {/* Client code */}
                        <InputField
                            extra="mb-4"
                            label="Codice Cliente*"
                            name="code"
                            placeholder="123e4567-e89b-12d3-a456-426614174000"
                            value={state.code || ""}
                            onChange={handleChange}
                            required={true}
                            state={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("password")
                                        ? "error"
                                        : null
                                    : null
                            }
                            error={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("password")
                                        ? message.errors.password
                                        : null
                                    : null
                            }
                        />

                        {message.hasOwnProperty("text") ? (
                            <div
                                className={
                                    "mb-6 ml-1 text-center text-base " +
                                    (message.type === "SUCCESS"
                                        ? "text-green-500"
                                        : message.type === "ERROR"
                                        ? "text-red-500"
                                        : message.type === "WARNING"
                                        ? "text-amber-500"
                                        : null)
                                }
                            >
                                <p>{message.text}</p>
                            </div>
                        ) : null}

                        <button
                            type="submit"
                            className="linear mt-2 w-full rounded-[8px] bg-brand-500 py-[12px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                        >
                            Registrati
                        </button>
                    </form>

                    <Link to="/auth/sign-in">
                        <button className="linear bg-transparent mt-3 w-full rounded-[8px] border border-brand-500 px-[34px] py-[12px] text-base font-bold uppercase text-brand-500 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 active:text-white dark:bg-brand-400 dark:text-brand-500 dark:hover:bg-brand-300 dark:hover:text-white dark:active:bg-brand-200 dark:active:text-white">
                            Indietro
                        </button>
                    </Link>
                </Card>
            </div>
        </div>
    );
}
